'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  indeterminate: _propTypes2.default.bool
};

var Input = function Input(_ref) {
  var indeterminate = _ref.indeterminate,
      otherProps = _objectWithoutProperties(_ref, ['indeterminate']);

  return _react2.default.createElement('input', _extends({
    className: 'mdc-checkbox__native-control',
    type: 'checkbox',
    ref: function ref(nativeComponent) {
      if (nativeComponent) {
        /* eslint-disable no-param-reassign */
        nativeComponent.indeterminate = indeterminate;
        /* eslint-enable no-param-reassign */
      }
    }
  }, otherProps));
};
Input.propTypes = propTypes;
exports.default = Input;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/Checkbox/Input.js
// module id = 290
// module chunks = 0